import { Card } from "primereact/card";
import { ProgressBar } from "primereact/progressbar";
import { Toolbar } from "primereact/toolbar";
import { useState } from "react";
import { ContactType } from "../../api/firebase/types/contact.types";
import ContactStore from "../../store/ContactStore";
import ContactTable from "./ContactTable";
import EmergencyContactsToolbarRightElements from "./ContactToolbar";

type ContactTableViewProps = {
  contacts?: ContactType[];
  setContacts: React.Dispatch<React.SetStateAction<ContactType[] | undefined>>;
};

const ContactTableView: React.FC<ContactTableViewProps> = (props) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [selectedContacts, setSelectedContacts] = useState<ContactType[]>();

  const onContactsDeleted = () => {
    setSelectedContacts(undefined);
    setShowLoader(false);
  };

  const onRowEditSave = (updatedContact: ContactType) => {
    setShowLoader(true);
    ContactStore.updateContact(updatedContact).finally(() =>
      setShowLoader(false)
    );
  };

  return (
    <Card className="contact-tableview p-col">
      {showLoader && <ProgressBar mode="indeterminate" />}
      <Toolbar
        left={() => <h2>Notfallkontakte</h2>}
        right={() => (
          <EmergencyContactsToolbarRightElements
            contactsToDelete={selectedContacts}
            onDelete={onContactsDeleted}
            showLoader={setShowLoader}
          />
        )}
      />
      <div className="p-mb-3">
        <i>Hier können Sie Notfallkontakte verwalten.</i>
      </div>
      {props.contacts && props.contacts.length > 0 ? (
        <ContactTable
          contacts={props.contacts}
          selectedContacts={selectedContacts}
          setSelectedContacts={setSelectedContacts}
          onSave={onRowEditSave}
          selection={selectedContacts}
        />
      ) : (
        <p>
          <i>Keine Notfallkontakte eingerichtet</i>
        </p>
      )}
    </Card>
  );
};

export default ContactTableView;
